import React from "react";
import { Link } from "react-router-dom";
import "./index.css";
import Wrapper from "../../../_hoc/Wrapper";
import Address from "./Address";
import ActionButtons from "./ActionButtons";
import CancelButton from "./CancelButton";
import userConstants from "../../../_constants/userConstants";
import UserInformation from "./UserInformation";
import { keys } from "lodash";
const UserWidget = ({
  user,
  actionButton,
  onAccept,
  onReject,
  cancel,
  onCancel
}) => {
  if (!user) {
    return (
      <Wrapper>
        <div class="widget-news widget-news-primary">
          <div class="widget-news-content">
            <div class="profile profile-transparent margin-bottom-10 margin-top-10">
              <div class="profile-image">
                <img src={userConstants.MALE_IMAGE} />
                <div class="profile-badges">
                  <a
                    title={`People who liked 's profile`}
                    class="profile-badges-left"
                  >
                    <i class="fa fa-thumbs-up" /> None
                  </a>
                  <a href="#" class="profile-badges-right">
                    <i class="fa fa-heartbeat" /> None
                  </a>
                </div>
                <div className={"profile-status away"} />
              </div>
              <div class="profile-info">
                <h4>Member Name</h4>
                <Address address={""} />
              </div>
              <div class="profile-buttons">
                <a className="btn btn-success btn-rounded padding-left-20 padding-right-20">
                  View Profile
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="widget-news">
          <div class="widget-news-content">
            <p>
              The story focuses on a boy named Kōichi Sakakibara who, upon
              transferring into Yomiyama Middle School and
            </p>
            <p>
              meeting the curious Mei Misaki, finds himself in a mystery
              revolving around students and people related to his class falling
              victim to gruesome, senseless deaths.
            </p>
          </div>
          <div class="widget-news-footer five-column">
            <div title="Profile Views">
              <i class="fa fa-vcard" /> 0
            </div>
            <div title="Profile Shortlist">
              <i class="fa fa-bookmark" /> 0
            </div>
            <div title="Expressed Interests">
              <i class="fa fa-heart" />0
            </div>
            <div title="Saved Profile">
              <i class="fa fa-save" /> 0
            </div>
            <div title="Favorites">
              <i class="fa fa-anchor" /> 0
            </div>
          </div>
          {actionButton ? (
            <ActionButtons onAccept={onAccept} onReject={onReject} />
          ) : null}
          {cancel ? <CancelButton onCancel={onCancel} /> : null}
        </div>
      </Wrapper>
    );
  } else {
    const keysCount = keys(user);
    if (keysCount.length === 1) {
      return null;
    }
    return (
      <Wrapper>
        <div class="widget-news widget-news-primary">
          <div class="widget-news-content">
            <div class="profile profile-transparent margin-bottom-10 margin-top-10">
              <div class="profile-image">
                <img src={user.imageURL} />
                <div class="profile-badges">
                  <a
                    title={`Members who liked ${user.name}'s profile`}
                    class="profile-badges-left"
                  >
                    <i class="fa fa-thumbs-up" />{" "}
                    {user.likes < 10
                      ? user.likes === 0
                        ? "None"
                        : `0${user.likes}`
                      : user.likes}
                  </a>
                  <a
                    class="profile-badges-right"
                    title={`Members who connected with ${user.name}`}
                  >
                    <i class="fa fa-heartbeat" />{" "}
                    {user.connects < 10
                      ? user.connects === 0
                        ? "None"
                        : `0${user.connects}`
                      : user.connects}
                  </a>
                </div>
                <div
                  className={
                    user.status === null
                      ? "profile-status away"
                      : user.status === "online"
                        ? "profile-status online"
                        : "profile-status away"
                  }
                />
              </div>
              <div class="profile-info">
                <h4>{user.name}</h4>
                <Address address={user.address} />
              </div>
              <div class="profile-buttons">
                <Link
                  className="btn btn-success btn-rounded padding-left-20 padding-right-20"
                  title={`View ${user.name}'s Profile`}
                  to={`/view-profile/${user.id}`}
                >
                  View Profile
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div class="widget-news">
          <UserInformation information={user.information} />
          <div class="widget-news-footer five-column">
            <div title={`Members who viewed ${user.name}'s Profile`}>
              <i class="fa fa-vcard" /> {user.profileViews}
            </div>
            <div title={`Members who shortlisted ${user.name}'s Profile`}>
              <i class="fa fa-bookmark" /> {user.likes}
            </div>
            <div
              title={`Members who expressed interest in ${user.name}'s Profile`}
            >
              <i class="fa fa-heart" /> {user.expressInterests}
            </div>
            <div title={`Members who saved ${user.name}'s Profile`}>
              <i class="fa fa-save" /> {user.saves}
            </div>
            <div title={`Members who favorited ${user.name}'s Profile`}>
              <i class="fa fa-anchor" /> {user.favorites}
            </div>
          </div>
          {actionButton ? (
            <ActionButtons onAccept={onAccept} onReject={onReject} />
          ) : null}
          {cancel ? <CancelButton onCancel={onCancel} /> : null}
        </div>
      </Wrapper>
    );
  }
};

export default UserWidget;



// WEBPACK FOOTER //
// ./src/_components/UI/UserWidget/index.js